import { bl_fi_generic_doc_hdr_RowClass, bl_fi_generic_doc_line_RowClass, bl_fi_my_einvoice_to_irb_hdr_RowClass, bl_fi_my_einvoice_to_irb_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceSearchResultContainer extends BaseContainerModel {
    bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass();
    bl_fi_generic_doc_line: bl_fi_generic_doc_line_RowClass[] = [];
}
